import { useEffect, useMemo, useState } from "react";
import { Card, CardContent, Pagination } from "@mui/material";
import classNames from "classnames";
import { format } from "date-fns";

import useStories from "../../models/stories/useStories";
import AutocompleteInput from "../../components/Autocomplete";
import useRestaurants from "../../models/restaurants/useRestaurants";

import "./styles.scss";

const StoryCard = ({ story }) => {
  const [showDetail, setShowDetail] = useState(false);

  const getStatusLabel = (status) => {
    switch (status) {
      case "CREATED":
        return "Pendiente";
      case "REJECTED":
        return "Rechazada";
      case "VALIDATED":
        return "Premiada";
      case "AI_VALIDATED":
        return "Validada";
    }
  };

  return (
    <Card
      elevation={0}
      className="StoryList__item"
      onClick={() => setShowDetail(!showDetail)}
    >
      <CardContent>
        <div
          className={classNames(
            "StoryList__item__label",
            story.status.toLowerCase()
          )}
        >
          {getStatusLabel(story.status)}
        </div>
        <div className="StoryList__item__image">
          <img src={story.image} />
        </div>
        {showDetail && (
          <div className="StoryList__item__detail">
            <div>
              <div className="StoryList__item__detail__label">Restaurante</div>
              <div className="StoryList__item__detail__value">
                {story.restaurant_name}
              </div>
            </div>
            <div>
              <div className="StoryList__item__detail__label">
                Cuenta de Instagram
              </div>
              <div className="StoryList__item__detail__value">
                <a
                  href={`https://www.instagram.com/${story.ig_account}`}
                  target="_blank"
                >
                  @{story.ig_account}
                </a>
              </div>
            </div>
            <div>
              <div className="StoryList__item__detail__label">
                Fecha de creación
              </div>
              <div className="StoryList__item__detail__value">
                {format(new Date(story.created_at), "dd/MM/yyyy hh:mm:ss")}
              </div>
            </div>
            {story.status !== "CREATED" && (
              <>
                <div>
                  <div className="StoryList__item__detail__label">
                    Validado por
                  </div>
                  <div className="StoryList__item__detail__value">
                    {story.checked_by_email || "IA"}
                  </div>
                </div>
                <div>
                  <div className="StoryList__item__detail__label">
                    Fecha de validación
                  </div>
                  <div className="StoryList__item__detail__value">
                    {format(new Date(story.updated_at), "dd/MM/yyyy hh:mm:ss")}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

const StoryList = () => {
  const { storyList, fetchStories } = useStories();
  const { restaurantList, fetchRestaurantList } = useRestaurants();
  const [status, setStatus] = useState("VALIDATED");
  const [restaurant, setRestaurant] = useState({ label: "Todos", value: "" });

  const options = [
    {
      value: "VALIDATED",
      label: "Premiadas",
    },
    {
      value: "AI_VALIDATED",
      label: "Validadas",
    },
    {
      value: "REJECTED",
      label: "Rechazadas",
    },
    {
      value: "",
      label: "Todas",
    },
  ];

  const restaurantOptions = useMemo(() => {
    return [
      { label: "Todos", value: "" },
      ...(restaurantList || []).map((item) => ({
        label: item.name,
        value: item.id,
      })),
    ];
  }, [restaurantList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [storyList]);

  useEffect(() => {
    fetchStories({ page: 1, status, restaurant: restaurant.value });
  }, [status, restaurant]);

  useEffect(() => {
    fetchRestaurantList();
  }, []);

  return (
    <div className="StoryList">
      <div className="StoryList__header">
        <h1>Listado de stories</h1>
        <div className="StoryList__filters">
          <div className="StoryList__select-restaurant">
            <AutocompleteInput
              value={restaurant}
              options={restaurantOptions}
              onChange={setRestaurant}
            />
          </div>
          <div className="StoryList__status">
            {options.map((item) => (
              <div
                key={item.value}
                className={classNames("StoryList__status__item", {
                  active: status == item.value,
                })}
                onClick={() => setStatus(item.value)}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="StoryList__list">
        {(storyList.items || []).map((item) => (
          <StoryCard key={item.id} story={item} />
        ))}
      </div>
      {Math.ceil(storyList.count / 12) > 1 && (
        <Pagination
          color="primary"
          count={Math.ceil(storyList.count / 12)}
          page={storyList.page}
          onChange={(_, page) =>
            fetchStories({ page, status, restaurant: restaurant.value })
          }
        />
      )}
    </div>
  );
};

export default StoryList;
